import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=77f44566&scoped=true"
import script from "./Master.vue?vue&type=script&lang=ts"
export * from "./Master.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f44566",
  null
  
)

export default component.exports